var _path, _path2, _path3, _path4, _path5, _g, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 42,
    viewBox: "0 0 184 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.615 33.3182V9.61914H182V33.3182H177.615Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.006 33.3182L159.633 9.61914H163.951L174.611 33.3182H170.023L160.881 11.9552H162.635L153.527 33.3182H149.006ZM153.898 27.8335L155.078 24.3803H167.83L169.011 27.8335H153.898Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.347 33.3182V9.61914H128.063C130.154 9.61914 131.942 9.9577 133.427 10.6348C134.933 11.3119 136.092 12.2825 136.901 13.5464C137.711 14.8104 138.116 16.3113 138.116 18.0492C138.116 19.7872 137.711 21.2881 136.901 22.552C136.092 23.7934 134.933 24.7527 133.427 25.4298C131.942 26.0843 130.154 26.4116 128.063 26.4116H120.776L122.733 24.4141V33.3182H118.347ZM133.798 33.3182L127.827 24.7188H132.516L138.521 33.3182H133.798ZM122.733 24.8881L120.776 22.789H127.86C129.794 22.789 131.245 22.3715 132.212 21.5364C133.202 20.7013 133.696 19.5389 133.696 18.0492C133.696 16.537 133.202 15.3746 132.212 14.5621C131.245 13.7495 129.794 13.3433 127.86 13.3433H120.776L122.733 11.1765V24.8881Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7953 19.4712H111.535V23.0937H99.7953V19.4712ZM100.133 29.6279H113.458V33.3182H95.7471V9.61914H112.986V13.3094H100.133V29.6279Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2294 33.3182L55.4028 9.61914H59.9571L66.9403 31.0498H64.68L71.9331 9.61914H75.9813L83.032 31.0498H80.8392L87.9911 9.61914H92.1742L84.3477 33.3182H79.6922L73.2488 13.9865H74.4632L67.9186 33.3182H63.2294Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_1648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5243 18.7216L47.6453 2L31.6117 22.5197H39.0983L30.9773 39.2413L47.0109 18.7216H39.5243Z",
    fill: "url(#paint0_linear_44_1648)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5183 20.6215C27.5183 14.1912 32.8085 8.95984 39.311 8.95984C39.7652 8.95984 40.2134 8.98544 40.6544 9.03509L41.8449 7.51155C41.0157 7.3558 40.1693 7.27734 39.311 7.27734C37.4896 7.27734 35.7224 7.63027 34.0582 8.32632C32.4512 8.99845 31.0082 9.96052 29.7692 11.1858C28.5302 12.411 27.5574 13.838 26.8777 15.4271C26.1738 17.0728 25.8169 18.8204 25.8169 20.6215C25.8169 22.4226 26.1738 24.1702 26.8777 25.8159C27.5573 27.405 28.5302 28.832 29.7692 30.0572C30.7252 31.0026 31.8027 31.791 32.9831 32.4107L36.3407 25.612L32.2328 29.9432C29.3717 27.8134 27.5183 24.4275 27.5183 20.6215Z",
    fill: "url(#paint1_linear_44_1648)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7446 15.4269C51.0649 13.8377 50.092 12.4108 48.853 11.1855C47.897 10.2402 46.8195 9.45174 45.6391 8.83203L42.6486 15.1403L46.3882 11.2987C49.25 13.4284 51.1039 16.8147 51.1039 20.6213C51.1039 27.0516 45.8138 32.283 39.3112 32.283C38.857 32.283 38.4088 32.2574 37.9678 32.2077L36.7773 33.7312C37.6065 33.887 38.4529 33.9655 39.3112 33.9655C41.1325 33.9655 42.8998 33.6125 44.564 32.9164C46.171 32.2443 47.614 31.2822 48.853 30.057C50.092 28.8318 51.0648 27.4048 51.7446 25.8157C52.4484 24.17 52.8053 22.4223 52.8053 20.6213C52.8053 18.8202 52.4484 17.0726 51.7446 15.4269Z",
    fill: "url(#paint2_linear_44_1648)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 33.3172V9.61816H11.7157C13.8073 9.61816 15.5953 9.95672 17.0796 10.6338C18.5865 11.311 19.7447 12.2815 20.5544 13.5454C21.364 14.8094 21.7688 16.3103 21.7688 18.0482C21.7688 19.7862 21.364 21.2871 20.5544 22.5511C19.7447 23.815 18.5865 24.7855 17.0796 25.4627C15.5953 26.1398 13.8073 26.4783 11.7157 26.4783H4.42894L6.38558 24.4131V33.3172H2ZM6.38558 24.8871L4.42894 22.7542H11.5133C13.4475 22.7542 14.8981 22.3479 15.8652 21.5354C16.8547 20.7003 17.3495 19.5379 17.3495 18.0482C17.3495 16.536 16.8547 15.3736 15.8652 14.5611C14.8981 13.7486 13.4475 13.3423 11.5133 13.3423H4.42894L6.38558 11.1755V24.8871Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_1648",
    x1: 39.3113,
    y1: -0.0152239,
    x2: 39.3113,
    y2: 41.2566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC4A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_1648",
    x1: 33.8309,
    y1: 5.91731,
    x2: 33.8309,
    y2: 33.7708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC4A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B733"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_44_1648",
    x1: 44.7913,
    y1: 7.472,
    x2: 44.7913,
    y2: 35.3255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC4A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B733"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_1648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.9882,
    height: 37.2413,
    fill: "white",
    transform: "translate(25.8169 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6cfff820146fa4c784ef04e1c32fe700.svg";
export { ForwardRef as ReactComponent };